import { Component } from '@angular/core';

@Component({
  selector: 'app-cards3-examples-17',
  templateUrl: './cards3-examples-17.component.html'
})
export class Cards3Examples17Component {}
